import React, { useState, useEffect } from "react";
import "react-chat-widget/lib/styles.css";
import { Avatar } from "@mui/material";
import { motion } from "framer-motion";
import ReactReadMoreReadLess from "react-read-more-read-less";
import { useNavigate, useParams } from "react-router-dom";
import host from "../host";
import ReactMarkdown from "react-markdown";
import nochat from "../assets/images/no-chatting.png";
export const PublicChat = () => {
  let { id } = useParams();
  const navigate = useNavigate();
  const myLongText =
    "At AgentAI, we pride ourselves on ofering a diverse array of AI-driven products and solutions that cater to the ever-evolving needs of our clients. From intelligent automation that streamlines complexworkflows to advanced analytics that extract valuable insights, our comprehensive portfolio is designed to empower businesses across sectors to thrive in the digital era.At AgentAI, we pride ourselves on ofering a diverse array of AI-driven ";
  const myLongTextquestion =
    "At AgentAI, we pride ourselves on ofering a diverse array of AI-driven products and solutions that cater to the ever-evolving needs of our clients. From intelligent automation that streamlines complexworkflows to advanced analytics that extract valuable insights, our comprehensive portfolio is designed to empower businesses across sectors to thrive in the digital era.At AgentAI, we pride ourselves on ofering a diverse array of AI-driven ";
  const [page, setPage] = useState(1);
  const totalPages = 3;
  const handleChange = (value) => {
    setPage(value);
  };
  const handleBack = () => {
    if (page > 1) {
      handleChange(page - 1);
    }
  };
  const handleNext = () => {
    if (page < totalPages) {
      handleChange(page + 1);
    }
  };

  const [snackbar, setSnackbar] = useState(false);
  const [message, setMessage] = useState("");
  const [severity, setSeverity] = useState("success");
  const onClose = () => {
    setSnackbar(false);
  };
  const [loading, setLoading] = useState(false);
  const [chatName, setChatName] = useState("");
  const [chatHistory, setChatHistory] = useState([]);
  const getSharedChat = () => {
    setLoading(true);
    fetch(host.chaturl + `/share/${id}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + localStorage.getItem("token"),
      },
    })
      .then((res) => {
        if (res.ok) {
          return res.json();
        } else if (res.status === 403) {
          res.json().then((data) => {
            if (data.detail === "Access denied" || data.detail === "Invalid token or expired token") {
              console.log("Access denied");
              navigate("/403");
            }
          });
        } else {
          setLoading(false);
          setSeverity("error");
          setMessage("Something went wrong");
          setSnackbar(true);
        }
      })
      .then((data) => {
        if (data) {
          setChatName(data.chat_name);
          const temp = data.chat_history.map((chat) => {
            return {
              brain: chat.brain_name ? chat.brain_name : "Browser",
              request: chat.human ? chat.human : "NA",
              response: chat.ai ? chat.ai : "NA",
              //   textSelection: chat.selected_text ? chat.selected_text : "",
              message_id: chat.id,
              //   standalone_question:
              //     chat.standalone_question !== ""
              //       ? chat.standalone_question
              //       : null,
              rawResponse: chat.ai ? chat.ai : "",
            };
          });
          setChatHistory(temp);
        }
        setLoading(false);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (!token) {
      navigate("/login", { state: { redirect: "/share/" + id } });
    } else if (id) {
      getSharedChat();
    }
  }, [id]);

  return (
    <>
      <>
        {/* <PageLoader /> */}
        <div className="viewer-wrapper">
          <div className="deskhome_chat_wrapper ">
            <div className="desk_chat_wrapper">
              <div className="desk_chat_body">
                <div className="chat_container">
                  <div className="desk_chat_panal" style={{ top: "0px" }}>
                    <div className="desk_chat_inner_box ">
                      <div className="desk_chat_contentwrapper">
                        <div className="desk_chat_contentbox">
                          <div className="desk_chat_bodydown">
                            <div className="desk_chat_body_Inner">
                              <div className="request_title text-center bg-white pt-2 pb-2">
                                <h4>{chatName ? chatName : ""}</h4>
                              </div>

                              <div className="desk_message_list_container">
                                <div className="desk_message_list">
                                  <section className="chat_message">
                                    <div className="container" style={{ maxWidth: "1140px" }}>
                                      <div className="row">
                                        <div className="col-md-12">
                                          <div class="chat_box_wrapper">
                                            <div class="chat_box_flex">
                                              <div className="left_all_content_wrapper">
                                                <div className="left_chat_content">
                                                  {chatHistory.length > 0 &&
                                                    chatHistory.map((chat, index) => {
                                                      return (
                                                        <>
                                                          <div className="chat_flex">
                                                            <div className="chat_avtar">
                                                              <Avatar sx={{ width: "35px", height: "35px", fontSize: "14px", backgroundColor: "#00bdd6" }}>HS</Avatar>
                                                            </div>
                                                            <div className="chat_content" style={{ backgroundColor: "#f3feff" }}>
                                                              {/* <div className='reply_view'  >
                                                                  <div className='chat_material_content'>
                                                                     <div className='chat_material_body'>
                                                                        <div className='chat_material_bar'> 
                                                                           <ReactReadMoreReadLess
                                                                           charLimit={350}
                                                                           readMoreText={"Read more ▼"}
                                                                           readLessText={"Read less ▲"}
                                                                           >
                                                                           {myLongText}
                                                                           </ReactReadMoreReadLess>
                                                                        </div>
                                                                     </div>
                                                                  </div>
                                                               </div> */}
                                                              <div className="chat_message_title">
                                                                <div className="chat_sender">you</div>
                                                                <h4>
                                                                  <ReactReadMoreReadLess charLimit={350} readMoreText={"Read more ▼"} readLessText={"Read less ▲"}>
                                                                    {chat.request}
                                                                  </ReactReadMoreReadLess>
                                                                </h4>
                                                              </div>
                                                            </div>
                                                          </div>
                                                          <div className="chat_flex">
                                                            <div className="chat_avtar  ">
                                                              <Avatar sx={{ width: "35px", height: "35px", fontSize: "16px", backgroundColor: "#8353e2" }}> AI </Avatar>
                                                            </div>
                                                            <div className="chat_content" style={{ backgroundColor: "#fbf9ff" }}>
                                                              <div className="answer_wrapper chat_sections">
                                                                <div className="answer-head">
                                                                  <div className="sources_title">
                                                                    <div className="sourse-icon">
                                                                      {/* 
                                                                        <FormatAlignLeftOutlinedIcon fontSize='small'/>
                                                                        */}
                                                                      <div className="chat_brain">
                                                                        <span>Browser </span>
                                                                      </div>
                                                                    </div>
                                                                    <psna>/</psna>
                                                                    <h5>Answer</h5>
                                                                  </div>
                                                                </div>
                                                                {/* 
                                                               <div className='answer_pagination'>
                                                                  <div className='Pagination_label'>
                                                                     <span>Business-Intelligence-and-Analytics.pdf</span>
                                                                  </div>
                                                                  <spam>:</spam>
                                                                  <Stack spacing={2}>
                                                                     <Pagination count={10} showFirstButton showLastButton />
                                                                     <Pagination count={5} hidePrevButton hideNextButton />
                                                                  </Stack>
                                                               </div>
                                                               */}
                                                                <div className="answer_body">
                                                                  <motion.div
                                                                    initial={{ opacity: 0, y: 5 }}
                                                                    animate={{ opacity: 1, y: 0 }}
                                                                    transition={{ duration: 0.4, delay: 0.2 }}
                                                                    className="answer_content   "
                                                                  >
                                                                    {chat.rawResponse && (
                                                                      <div>
                                                                        {chat.rawResponse
                                                                          .split("\n")
                                                                          .filter((row) => row.trim().length > 0 && !/^[-| ]+$/.test(row))
                                                                          .map((row, index) => {
                                                                            if (row.includes("|")) {
                                                                              // This is a table row
                                                                              return (
                                                                                <table
                                                                                  key={index}
                                                                                  style={{ border: "1px solid black", borderCollapse: "collapse", tableLayout: "fixed", width: "100%" }}
                                                                                >
                                                                                  <tbody>
                                                                                    <tr>
                                                                                      {row
                                                                                        .split("|")
                                                                                        .filter((cell, cellIndex) => cell.trim().length > 0 && cellIndex > 0 && cellIndex < row.split("|").length - 1)
                                                                                        .map((cell, cellIndex) => (
                                                                                          <td key={cellIndex} style={{ border: "1px solid black", padding: "5px" }}>
                                                                                            <ReactMarkdown>{cell.trim()}</ReactMarkdown>
                                                                                          </td>
                                                                                        ))}
                                                                                    </tr>
                                                                                  </tbody>
                                                                                </table>
                                                                              );
                                                                            } else {
                                                                              // This is a normal text row
                                                                              return <ReactMarkdown key={index}>{row}</ReactMarkdown>;
                                                                            }
                                                                          })}
                                                                      </div>
                                                                    )}
                                                                  </motion.div>
                                                                </div>
                                                              </div>
                                                            </div>
                                                          </div>
                                                        </>
                                                      );
                                                    })}
                                                  {chatHistory.length === 0 && (
                                                    <div className="no_content-wrapper " style={{ display: "block" }}>
                                                      <div className="no-content-box">
                                                        <div className="no_content-icon">
                                                          <img src={nochat} alt="" height={100} />
                                                        </div>
                                                        <div className="no_content-title">No chats found</div>
                                                        <div className="no_content-pera">
                                                          <span>
                                                            {" "}
                                                            Click the <strong>'Explore Ngnext - KnowledgeHub'</strong> button below to unlock our platform
                                                          </span>
                                                        </div>
                                                      </div>
                                                    </div>
                                                  )}
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </section>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div className="public_chat_button" style={{ position: "absolute", bottom: "15px", left: "0px", right: "0px", textAlign: "center" }}>
                          <button
                            type="button"
                            className="btn btn-secondary"
                            style={{ fontSize: "16px" }}
                            onClick={() => {
                              navigate("/sign-up");
                            }}
                          >
                            Explore Ngnext - KnowledgeHub
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    </>
  );
};
